const testingTool = {
  header: 'Controller Testing Tool',
  serial_number: 'Serial number',
  site_id: 'Site ID',
  site_name: 'Site Name',
  validation_code: 'Validation Code',
  assign_to_site: 'Assign to Site',
  xml_command: 'XML Command',
  send_command: 'Send Command',
  remove_site: 'Remove Site',
  panel_alive: 'Panel alive',
  last_signal: 'Last signal ',
  received: 'Received',
  sent: 'Sent',
  msg_in_memory: 'Messages in Memory',
  log: 'Log',
  copy_clip: 'Copy to Clipboard',
  reset_msg:
    'Press Confirm button if you want to factory reset the controller. \n Press Cancel if you only want unassign the controller from site.',
  btn_factory_reset: 'Factory reset and remove',
  btn_unassign: 'Only remove',
  ping_response_from_serial: 'Ping response from serial:',
  assign_site_label: 'Assign site:',
  ping_label: 'Ping:',
  unassign_site_label: 'Unassign site:',
  command_label: 'Command:',
  key_label: 'Key:',
};

export default testingTool;
